var exports = {
  "O": "xa15a2ab7--2ca500--group",
};

module.exports = exports;
